var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["ccd-export-contacts", "ccd-export-" + _vm.postFixer],
      attrs: { id: "ccd-export-" + _vm.postFixer },
    },
    [
      _c(
        "div",
        { staticClass: "export-filter-condtions" },
        [
          _vm.showSelectBuilding
            ? _c(
                "div",
                {
                  staticClass: "building-multi-select",
                  class: _vm.showBuildingError,
                },
                [
                  _c("label", { staticClass: "emphasis" }, [
                    _vm._v(_vm._s(_vm.$t("project.building"))),
                  ]),
                  _vm._v(" "),
                  _c("HKLMultiSelect", {
                    staticClass: "building-multi-select__control",
                    attrs: {
                      value: _vm.pickedBuildingCodes,
                      options: _vm.buildingHklOptions,
                      placeholder: "",
                    },
                    on: { change: _vm.onBuildingsChange },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("addtional-content"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }